import CheckBox from '@app/components/CheckBox'
import * as AccountModule from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Link, Redirect, RouteComponentProps } from 'react-router-dom'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
import * as LoginModule from '../modules/login'
import './LoginPage.scss'

type LoginPageProps = AccountModule.IAccountState &
  LoginModule.ILoginState &
  typeof LoginModule.actionCreators &
  RouteComponentProps<{ returnUrl?: string }>

interface ILoginPageState {
  password: string
  rememberMe: boolean
  username: string
}

export default class LoginPage extends React.Component<
  LoginPageProps,
  ILoginPageState
> {
  constructor(props: LoginPageProps) {
    super(props)
    this.state = {
      password: '',
      rememberMe: false,
      username: '',
    }
    bindFunctions(this)
  }

  public render() {
    if (this.props.accessToken) {
      const defaultUrl = '/'
      const returnUrl =
        // @ts-expect-error - location.state type doesn't include 'from' property
        this.props.location.state && this.props.location.state.from
          // @ts-expect-error - location.state type doesn't include 'from' property
          ? this.props.location.state.from
          : defaultUrl
      return <Redirect to={returnUrl} />
    }

    return (
      <DocumentTitle title='Login'>
        <div className='login-background-container'>
          <div className='login-inner-container'>
            <div className='login-right'>
              <img
                className='img-fluid'
                src='/images/HBConnectingOurWorld.gif'
              />
            </div>
            <div className='login-left'>
              <Form onSubmit={this._onSubmitLogin}>
                <FormGroup>
                  <Input
                    autoFocus
                    id='username'
                    name='username'
                    placeholder='email'
                    onChange={(e) => this._onUpdateUsername(e.target.value)}
                    value={this.state.username}
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    id='password'
                    name='password'
                    type='password'
                    placeholder='password'
                    onChange={(e) => this._onUpdatePassword(e.target.value)}
                    value={this.state.password}
                  />
                </FormGroup>
                <FormGroup className='text-left'>
                  <Label check>
                    <CheckBox
                      onChange={(newValue) => {
                        this._onUpdateRememberMe(newValue)
                      }}
                      value={this.state.rememberMe}
                    >
                      remember me
                    </CheckBox>
                  </Label>
                </FormGroup>
                <Button
                  color='primary'
                  className='login-button'
                  disabled={this.props.isAttemptingLogin}
                >
                  Connect
                </Button>
                <div className='text-danger'>{this.props.error}</div>
                <div className='login-footer text-center'>
                  <Link className='small text-muted' to='/forgotPassword'>
                    Forgot Password
                  </Link>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _onSubmitLogin(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    this.props.attemptLogin(
      this.state.username,
      this.state.password,
      this.state.rememberMe,
    )
  }

  private _onUpdateUsername(username: string) {
    this.setState({
      username,
    })
  }

  private _onUpdatePassword(password: string) {
    this.setState({
      password,
    })
  }

  private _onUpdateRememberMe(rememberMe: boolean) {
    this.setState({
      rememberMe,
    })
  }
}
